(function () {
  class FreeSpinsMeter extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      StateMachine.Create(this);
    }

    initialise() {
      this._jsonPath = this.name + ':freeSpinsMeterContainer';
      this.freeSpinsValue = undefined;
      this.freeSpinsText = undefined;

      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.freeSpinsValue = resourceManager.get(this._jsonPath + ':freeSpinsValue');
      this.freeSpinsText = resourceManager.get(this._jsonPath + ':freeSpinsText');
    }

    setMeterValues(spins, totalSpins) {
      this.freeSpinsValue.setTranslationParameters(spins, totalSpins);
    }
  }

  create = function (json) {
    return new FreeSpinsMeter();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('freeSpinsMeter', create, initialise, getFilesRequired);
})();
